<template>
    <transition name="menu-slide">
        <div v-if="open" class="main-menu">
            <div class="main-menu__top">
                <img class="main-menu__image"
                     :src="'/images/menuicons/' + menuImg"
                     @click="openUrl"
                >

                <icon-button class="close-button"
                             @click="closeMenu"
                >
                    close
                </icon-button>
            </div>

            <nav class="main-navigation">
                <div class="main-navigation__item"
                     @click="goto('fotodatenbank')"
                     v-if="userLev.indexOf(2) > -1"
                     @mouseover="changeImg('fotodatenbank')"
                     @mouseleave="returnImg()">
                    Fotodatenbank
                </div>

                <div class="main-navigation__item"
                     @click="goto('kontakt')"
                     v-if="userLev.indexOf(1) > -1"
                     @mouseover="changeImg('kontakt')"
                     @mouseleave="returnImg()">
                    Kontakt
                </div>

                <!-- ======================= settings =================== -->
                <div class="main-navigation__item"
                     @click="openSettings()"
                     v-if="userLev.indexOf(1) > -1"
                     @mouseover="changeImg('settings')"
                     @mouseleave="returnImg()">
                    Einstellungen
                    <i id="settingDown" class="material-icons" v-if="!settingsAreOpen">keyboard_arrow_down</i>
                    <i id="settingUp" class="material-icons" v-if="settingsAreOpen">keyboard_arrow_up</i>
                </div>
                <div class="main-navigation__sub" v-if="settingsAreOpen">
                    <div class="main-navigation__item main-navigation__item--sub"
                         @click="goto('usersettings')"
                         v-if="userLev.indexOf(1) > -1"
                         @mouseover="changeImg('settings')"
                         @mouseleave="returnImg()">
                        Personalien
                    </div>
                    <div class="main-navigation__item main-navigation__item--sub"
                         @click="goto('favtrains')"
                         v-if="userLev.indexOf(1) > -1"
                         @mouseover="changeImg('settings')"
                         @mouseleave="returnImg()">
                        Züge
                    </div>
                    <div class="main-navigation__item main-navigation__item--sub"
                         @click="goto('anb')"
                         v-if="userLev.indexOf(1) > -1"
                         @mouseover="changeImg('settings')"
                         @mouseleave="returnImg()">
                        ANB
                    </div>
                </div>

                <!-- ======================= lager =================== -->
                <div class="main-navigation__item"
                     @click="openLager()"
                     v-if="userLev.indexOf(6) > -1 || userLev.indexOf(7) > -1 || userLev.indexOf(8) > -1"
                     @mouseover="changeImg('lager')"
                     @mouseleave="returnImg()">
                    Lager
                    <i id="lagerDown" class="material-icons" v-if="!lagerIsOpen">keyboard_arrow_down</i>
                    <i id="lagerUp" class="material-icons" v-if="lagerIsOpen">keyboard_arrow_up</i>
                </div>
                <div class="main-navigation__item main-navigation__item--sub"
                     @click="goto('Lagerübersicht')"
                     v-if="userLev.indexOf(6) > -1 && lagerIsOpen"
                     @mouseover="changeImg('lager')"
                     @mouseleave="returnImg()">
                    Lagerübersicht
                </div>

            <!-- =============== Primär ==============-->
                <div class="main-navigation__item main-navigation__item--sub"
                     @click="openPrimaer()"
                     v-if="(userLev.indexOf(6)  > -1 || userLev.indexOf(7) > -1 )&& lagerIsOpen"
                     @mouseover="changeImg('lager')"
                     @mouseleave="returnImg()">
                    SBB Primär
                    <i id="primaerDown" class="material-icons" v-if="!primaerIsOpen">keyboard_arrow_down</i>
                    <i id="primaerUp" class="material-icons" v-if="primaerIsOpen">keyboard_arrow_up</i>
                </div>
                <div class="main-navigation__sub" v-if="lagerIsOpen && primaerIsOpen">
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('neuebestellung')"
                         v-if="userLev.indexOf(6) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Neue<br>Bestellungen
                    </div>
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('bestelluebersicht')"
                         v-if="userLev.indexOf(7) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Offene<br>Bestellungen
                    </div>
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('bestelluebersichtDone')"
                         v-if="userLev.indexOf(6) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Abgeschlossene<br>
                        Bestellungen
                    </div>
                </div>

            <!-- =============== Sekundär ==============-->
                <div class="main-navigation__item main-navigation__item--sub"
                     @click="openSekundaer()"
                     v-if="(userLev.indexOf(8)  > -1 || userLev.indexOf(7) > -1) && lagerIsOpen"
                     @mouseover="changeImg('lager')"
                     @mouseleave="returnImg()">
                    SBB Sekundär
                    <i id="sekundaerDown" class="material-icons" v-if="!sekundaerIsOpen">keyboard_arrow_down</i>
                    <i id="sekundaerUp" class="material-icons" v-if="sekundaerIsOpen">keyboard_arrow_up</i>
                </div>

                <div class="main-navigation__sub" v-if="lagerIsOpen && sekundaerIsOpen">
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('neuebestellungSekundaer')"
                         v-if="userLev.indexOf(8) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Neue<br>Bestellungen
                    </div>
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('bestelluebersichtSekundaer')"
                         v-if="userLev.indexOf(7) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Offene<br>Bestellungen
                    </div>
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('bestelluebersichtSekundaerDone')"
                         v-if="userLev.indexOf(8) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Abgeschlossene<br>
                        Bestellungen
                    </div>
                </div>

            <!-- =============== SRM ==============-->
                <div class="main-navigation__item main-navigation__item--sub"
                     @click="openSRM()"
                     v-if="(userLev.indexOf(8)  > -1 || userLev.indexOf(7) > -1) && lagerIsOpen"
                     @mouseover="changeImg('lager')"
                     @mouseleave="returnImg()">
                    SRM
                    <i id="srmDown" class="material-icons" v-if="!srmIsOpen">keyboard_arrow_down</i>
                    <i id="srmUp" class="material-icons" v-if="srmIsOpen">keyboard_arrow_up</i>
                </div>

                <div class="main-navigation__sub" v-if="lagerIsOpen && srmIsOpen">
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('neuebestellungVerbrauch')"
                         v-if="userLev.indexOf(8) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Neue<br>Bestellungen
                    </div>
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('bestelluebersichtVerbrauch')"
                         v-if="userLev.indexOf(7) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Offene<br>Bestellungen
                    </div>
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('bestelluebersichtVerbrauchDone')"
                         v-if="userLev.indexOf(8) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Abgeschlossene<br>
                        Bestellungen
                    </div>
                </div>

            <!-- =============== SFS ==============-->
                <div class="main-navigation__item main-navigation__item--sub"
                     @click="openSFS()"
                     v-if="(userLev.indexOf(9)  > -1 || userLev.indexOf(7) > -1) && lagerIsOpen"
                     @mouseover="changeImg('lager')"
                     @mouseleave="returnImg()">
                    SFS
                    <i id="sfsDown" class="material-icons" v-if="!sfsIsOpen">keyboard_arrow_down</i>
                    <i id="sfsUp" class="material-icons" v-if="sfsIsOpen">keyboard_arrow_up</i>
                </div>

                <div class="main-navigation__sub" v-if="lagerIsOpen && sfsIsOpen">
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('neuebestellungSfs')"
                         v-if="userLev.indexOf(9) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Neue<br>Bestellungen
                    </div>
                     <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('bestelluebersichtSfs')"
                         v-if="userLev.indexOf(7) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Offene<br>Bestellungen
                    </div>
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('bestelluebersichtSfsDone')"
                         v-if="userLev.indexOf(9) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Abgeschlossene<br>
                        Bestellungen
                    </div>
                </div>

            <!-- =============== EM ==============-->
                <div class="main-navigation__item main-navigation__item--sub"
                     @click="openEM()"
                     v-if="(userLev.indexOf('A')  > -1 || userLev.indexOf(7) > -1) && lagerIsOpen"
                     @mouseover="changeImg('lager')"
                     @mouseleave="returnImg()">
                    EM
                    <i id="emDown" class="material-icons" v-if="!emIsOpen">keyboard_arrow_down</i>
                    <i id="emUp" class="material-icons" v-if="emIsOpen">keyboard_arrow_up</i>
                </div>

                <div class="main-navigation__sub" v-if="lagerIsOpen && emIsOpen">
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('neuebestellungEM')"
                         v-if="userLev.indexOf('A') > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Neue<br>Bestellungen
                    </div>
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('bestelluebersichtEM')"
                         v-if="userLev.indexOf(7) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Offene<br>Bestellungen
                    </div>
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('bestelluebersichtEMDone')"
                         v-if="userLev.indexOf('A') > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Abgeschlossene<br>
                        Bestellungen
                    </div>
                </div>

            <!-- =============== küchen ==============-->
                <div class="main-navigation__item main-navigation__item--sub"
                     @click="openKuechen()"
                     v-if="(userLev.indexOf(6)  > -1 || userLev.indexOf(7) > -1) && lagerIsOpen"
                     @mouseover="changeImg('lager')"
                     @mouseleave="returnImg()">
                    Küchen
                    <i id="kuechenDown" class="material-icons" v-if="!kuechenIsOpen">keyboard_arrow_down</i>
                    <i id="kuechenUp" class="material-icons" v-if="kuechenIsOpen">keyboard_arrow_up</i>
                </div>

                <div class="main-navigation__sub" v-if="lagerIsOpen && kuechenIsOpen">
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('neuebestellungKuechen')"
                         v-if="userLev.indexOf(6) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Neue<br>Bestellungen
                    </div>
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('bestelluebersichtKuechen')"
                         v-if="userLev.indexOf(7) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Offene<br>Bestellungen
                    </div>
                    <div class="main-navigation__item main-navigation__item--sub-sub"
                         @click="goto('bestelluebersichtKuechenDone')"
                         v-if="userLev.indexOf(6) > -1"
                         @mouseover="changeImg('lager')"
                         @mouseleave="returnImg()">
                        Abgeschlossene<br>
                        Bestellungen
                    </div>
                </div>
                <div class="main-navigation__item main-navigation__item--sub"
                     @click="goto('Bestelldokumente')"
                     v-if="userLev.indexOf(6) > -1 && lagerIsOpen"
                     @mouseover="changeImg('lager')"
                     @mouseleave="returnImg()">
                    Bestelldokumente
                </div>
                <div class="main-navigation__item main-navigation__item--sub"
                     @click="goto('upload')"
                     v-if="userLev.indexOf(6) > -1 && lagerIsOpen"
                     @mouseover="changeImg('lager')"
                     @mouseleave="returnImg()">
                    Uploads
                </div>

                <div class="main-navigation__item"
                     @click="openAdmin()"
                     v-if="userLev.indexOf(0) > -1"
                     @mouseover="changeImg('user')"
                     @mouseleave="returnImg()">
                    Admin
                    <i id="adminDown" class="material-icons" v-if="!adminIsOpen">keyboard_arrow_down</i>
                    <i id="adminUp" class="material-icons" v-if="adminIsOpen">keyboard_arrow_up</i>
                </div>
                <div class="main-navigation__sub" v-if="adminIsOpen">
                    <div class="main-navigation__item main-navigation__item--sub"
                         @click="goto('users')"
                         v-if="userLev.indexOf(0) > -1"
                         @mouseover="changeImg('users')"
                         @mouseleave="returnImg()">
                        Users
                    </div>
                    <div class="main-navigation__item main-navigation__item--sub"
                         @click="goto('sendmail')"
                         v-if="userLev.indexOf(0) > -1"
                         @mouseover="changeImg('kontakt')"
                         @mouseleave="returnImg()">
                        Send mail
                    </div>
                     <div class="main-navigation__item main-navigation__item--sub"
                         @click="goto('stao')"
                         v-if="userLev.indexOf(0) > -1"
                         @mouseover="changeImg('lea')"
                         @mouseleave="returnImg()">
                        Staos
                        <!-- <hr class="menuUndermenuDevider"> -->
                    </div>
                </div>

            </nav>

            <div class="spacer"></div>

            <default-button :variations="['full-width', 'icon']" @click="logout">
                exit_to_app
            </default-button>
        </div>
    </transition>
</template>

<script>
import DefaultButton from '../common/default-button';
import IconButton from '../common/icon-button';

export default {
    components: { IconButton, DefaultButton },
    data() {
        return {}
    },
    computed: {
        open() {
            return this.$store.getters['menu/open'];
        },
        menuImg() {
            return this.$store.getters['menu/menuImg'];
        },
        userLev() {
            return this.$store.getters['user/autLev'];
        },
        stao() {
            return this.$store.getters['user/userStao'];
        },
        settingsAreOpen() {
            return this.$store.getters['menu/openSettings'];
        },
        lagerIsOpen() {
            return this.$store.getters['menu/openLager'];
        },
        primaerIsOpen() {
            return this.$store.getters['menu/openPrimaer'];
        },
        sekundaerIsOpen() {
            return this.$store.getters['menu/openSekundaer'];
        },
        srmIsOpen() {
            return this.$store.getters['menu/openSRM'];
        },
        sfsIsOpen() {
            return this.$store.getters['menu/openSFS'];
        },
        emIsOpen() {
            return this.$store.getters['menu/openEM'];
        },
        kuechenIsOpen() {
            return this.$store.getters['menu/openKuechen'];
        },
        adminIsOpen() {
            return this.$store.getters['menu/openAdmin'];
        }
    },
    watch: {
        open() {
            // on open send the current rout to the menuImg
            this.$store.dispatch('menu/menuImg', 'lea'); // this.$route.name);
        }
    },
    methods: {
        closeMenu() {
            this.$store.dispatch('menu/open', false);
        },
        logout() {
            // close the menu
            this.$store.dispatch('menu/open', false);
            // get rid of the user store info
            this.$store.dispatch('user/logout');
        },
        goto(x) {
            this.closeMenu();

            if (x === 'fotodatenbank') {
                this.$router.push('/fotodatenbank/search');
            } else if (x === 'upload') {
                this.$router.push('/lager/upload/' + this.stao);
            } else if (x === 'neuebestellung') {
                this.$router.push('/lager/neuebestellung/' + this.stao + '/0/');
            } else if (x === 'neuebestellungSekundaer') {
                this.$router.push('/lager/neuebestellung/' + this.stao + '/4/');
            } else if (x === 'neuebestellungKuechen') {
                this.$router.push('/lager/neuebestellung/' + this.stao + '/5/');
            } else if (x === 'neuebestellungVerbrauch') {
                if (this.userLev.indexOf(8) > -1) {
                    this.$router.push('/lager/neuebestellung/' + this.stao + '/1/');
                } else {
                    this.$router.push('/lager/neuebestellung/' + this.stao + '/0/');
                }
            } else if (x === 'neuebestellungSfs') {
                if (this.userLev.indexOf(9) > -1) {
                    this.$router.push('/lager/neuebestellung/' + this.stao + '/2/');
                } else {
                    this.$router.push('/lager/neuebestellung/' + this.stao + '/0/');
                }
            } else if (x === 'neuebestellungEM') {
                if (this.userLev.indexOf('A') > -1) {
                    this.$router.push('/lager/neuebestellung/' + this.stao + '/3/');
                } else {
                    this.$router.push('/lager/neuebestellung/' + this.stao + '/0/');
                }

            } else if (x === 'bestelluebersicht') {
                this.$router.push('/lager/bestelluebersicht/' + this.stao + '/0/0/');
            } else if (x === 'bestelluebersichtVerbrauch') {
                this.$router.push('/lager/bestelluebersicht/' + this.stao + '/1/0/');
            } else if (x === 'bestelluebersichtSfs') {
                this.$router.push('/lager/bestelluebersicht/' + this.stao + '/2/0/');
            } else if (x === 'bestelluebersichtEM') {
                this.$router.push('/lager/bestelluebersicht/' + this.stao + '/3/0/');
            } else if (x === 'bestelluebersichtSekundaer') {
                this.$router.push('/lager/bestelluebersicht/' + this.stao + '/4/0/');
            } else if (x === 'bestelluebersichtKuechen') {
                this.$router.push('/lager/bestelluebersicht/' + this.stao + '/5/0/');
            } else if (x === 'bestelluebersichtDone') {
                this.$router.push('/lager/bestelluebersicht/' + this.stao + '/0/1/');
            } else if (x === 'bestelluebersichtVerbrauchDone') {
                this.$router.push('/lager/bestelluebersicht/' + this.stao + '/1/1/');
            } else if (x === 'bestelluebersichtSfsDone') {
                this.$router.push('/lager/bestelluebersicht/' + this.stao + '/2/1/');
            } else if (x === 'bestelluebersichtEMDone') {
                this.$router.push('/lager/bestelluebersicht/' + this.stao + '/3/1/');
            } else if (x === 'bestelluebersichtSekundaerDone') {
                this.$router.push('/lager/bestelluebersicht/' + this.stao + '/4/1/');
            } else if (x === 'bestelluebersichtKuechenDone') {
                this.$router.push('/lager/bestelluebersicht/' + this.stao + '/5/1/');
            } else if (x === 'Lagerübersicht') {
                this.$router.push('/lager/bestandsuebersicht/' + this.stao);
            } else if (x === 'Bestelldokumente') {
                this.$router.push('/lager/bestellfiles/' + this.stao);
            } else {
                this.$router.push({ name: x });
            }
        },
        // change the image to the menuitem being hovered over
        changeImg(x) {
            this.$store.dispatch('menu/menuImg', x);
        },
        // turn the img back to the one of the open page
        returnImg() {
            this.$store.dispatch('menu/menuImg', 'lea');
        },
        openUrl() {
            this.$store.dispatch('menu/openUrl');
        },
        openSettings() {
            this.$store.dispatch('menu/openSettings');
        },
        openLager() {
            this.$store.dispatch('menu/openLager');
        },
        openPrimaer() {
            this.$store.dispatch('menu/openPrimaer');
        },
        openSekundaer() {
            this.$store.dispatch('menu/openSekundaer');
        },
        openSRM() {
            this.$store.dispatch('menu/openSRM');
        },
        openSFS() {
            this.$store.dispatch('menu/openSFS');
        },
        openEM() {
            this.$store.dispatch('menu/openEM');
        },
        openKuechen() {
            this.$store.dispatch('menu/openKuechen');
        },
        openAdmin() {
            this.$store.dispatch('menu/openAdmin');
        }
    },
    created() {
        this.$store.dispatch('fotodatenbank/trains');
        this.$store.dispatch('user/getFavTrains');
        this.$store.dispatch('menu/leaImg');
    }
}
</script>

<style scoped lang="scss">
.menu-slide-enter-active {
    transition: all .3s ease;
}

.menu-slide-leave-active {
    transition: all .3s ease;
}

.menu-slide-enter {
    transform: translateX(-100%);
}

.menu-slide-leave-to {
    transform: translateX(-100%);
}

.main-menu {
    box-shadow: 0 0 5rem rgba($color-black, 0.2);
    background-color: $color-white;
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 19rem;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 9999;
}

.spacer {
    flex: 1;
}

.main-menu__top {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
    padding-top: 2rem;
}

.main-menu__image {
    height: 12.5rem;
    cursor: pointer;
    max-width: 19rem;

    @include medium {
        height: 14rem;
    }
}

.close-button {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
}

.logout-button {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2.5rem;
    width: 100%;
    color: $color-action-contrast;
    background-color: $color-action;
    cursor: pointer;
}

.main-navigation {
    width: 100%;
    padding-bottom: 2rem;
    overflow-y: auto;
    overflow-x: hidden;
}

.main-navigation__item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 1.5rem;
    cursor: pointer;
    padding-left: 0.625rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.main-navigation__item--sub {
    font-size: 1.5rem;
    cursor: pointer;
    padding-left: 2.5rem;
    width: 100%;
}

.main-navigation__item--sub-sub {
    font-size: 1.2rem;
    cursor: pointer;
    padding-left: 4.0rem;
    width: 100%;
}

#settingDown {
    font-size: 2rem;
}

#settingUp {
    font-size: 2rem;
}

#lagerDown {
    font-size: 2rem;
}

#lagerUp {
    font-size: 2rem;
}

#adminDown {
    font-size: 2rem;
}

#adminUp {
    font-size: 2rem;
}
</style>
